export const dropdownMenuSeparator = { text: '', action: () => { }, path: [] };
